import { setZoomValueType } from '../ZoomConstants';

import initialState from './initialState';


export default function zoomReducer (state = initialState, action) {
  switch(action.type) {

    case setZoomValueType: {
      const { key, value } = action.payload;

      return state.set(key, value);
    }

    default: {
      return state;
    }
  }
}
